import { faPencil } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useMemo, useState } from 'react';
import { Spinner } from '../../../../../components/Spinner';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';

function ConsumerPopoverSearchAggregatorForm({
  consumerAggregatorId,
  aggregators,
  updateConsumer,
  showInInputFormat,
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [spinner, setSpinner] = useState(false);

  const [search, setSearch] = useState('');

  const filteredAggregators = useMemo(() => {
    if (search === '') return aggregators;

    return aggregators.filter(aggregator =>
      aggregator.name.toLowerCase().includes(search.toLowerCase()),
    );
  }, [search, aggregators]);

  const handleAggregatorClick = async aggregatorId => {
    setSpinner(true);
    await updateConsumer(aggregatorId);
    setSpinner(false);

    setIsOpen(false);
    setSearch('');
  };

  const handleToggle = () => {
    setSearch('');
    setIsOpen(!isOpen);
  };

  return (
    <OverlayTrigger
      trigger="click"
      placement="bottom-start"
      show={isOpen}
      popperConfig={{ modifiers: [{ name: 'offset', options: { offset: [0, 0] } }] }}
      overlay={
        <Popover className="custom-popover">
          <Popover.Body className="bo-consumer-popover-form-menu">
            <Spinner visible={spinner}>
              <Form.Label className="bo-consumer-popover-form-menu-label">Search</Form.Label>
              <Form.Control
                type="text"
                className="bo-consumer-popover-form-menu-input bo-w-200"
                value={search}
                onChange={e => setSearch(e.target.value)}
                disabled={aggregators.length === 0}
              />
              <div className="bo-consumer-popover-form-content-box">
                {filteredAggregators.map(aggregator => (
                  <Button
                    className="bo-consumer-popover-form-content-button"
                    key={aggregator.id}
                    onClick={() => handleAggregatorClick(aggregator.id)}
                  >
                    <p className="bo-consumer-text text-start">{aggregator.name}</p>
                  </Button>
                ))}
              </div>
              <div className="mt-2 d-flex justify-content-center">
                <Button className="bo-common-button" onClick={handleToggle}>
                  Cancel
                </Button>
              </div>
            </Spinner>
          </Popover.Body>
        </Popover>
      }
    >
      {showInInputFormat ? (
        <div>
          <Form.Label className="bo-consumer-input-label">Employer</Form.Label>
          <Button
            className="bo-consumer-text-input-container"
            onClick={handleToggle}
            disabled={aggregators.length === 0}
          >
            <div className="d-flex align-items-center w-100">
              <Form.Control
                className="bo-consumer-text-input bo-w-150"
                type="text"
                readOnly
                value={
                  aggregators.find(aggregator => aggregator.id === Number(consumerAggregatorId))
                    ?.name || 'Loading...'
                }
              />
            </div>
            <div className="bo-consumer-input-button-container">
              <div className="bo-consumer-input-button-icon">
                <FontAwesomeIcon icon={faPencil} color="#5946A4" size="sm" />
              </div>
            </div>
          </Button>
        </div>
      ) : (
        <Button
          onClick={handleToggle}
          className="bo-consumer-popover-form-toggle w-auto"
          disabled={aggregators.length === 0}
        >
          <p className="bo-consumer-text p-0 m-0">
            {aggregators.find(aggregator => aggregator.id === Number(consumerAggregatorId))?.name ||
              'Loading...'}
          </p>
          <div
            className={`pb-1 bo-consumer-popover-form-toggle-icon ${
              isOpen ? 'bo-consumer-popover-form-toggle-icon-active' : ''
            }`}
          >
            <FontAwesomeIcon icon={faPencil} color="#5946A4" size="xs" />
          </div>
        </Button>
      )}
    </OverlayTrigger>
  );
}
export default ConsumerPopoverSearchAggregatorForm;
